/**
 * Loads an image source as a background-image that will center and cover
 * a container of any size
 */
import React, { useState } from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import Modal from '@material-ui/core/Modal'
import IconButton from '@material-ui/core/IconButton'
import Close from '@material-ui/icons/Close'

const useStyles = makeStyles(theme => ({
  modalBody: {
    outline: 'none',
  },
  root: ({ src, width, height, popup }) => ({
    height: height ?? '100%',
    width: width ?? '100%',
    backgroundImage: `url(${src})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    cursor: popup ? 'pointer' : 'auto',
    [theme.breakpoints.down('xs')]: {
      borderRadius: 10,
    },
  }),
  modalImage: ({ src }) => ({
    height: '95vh',
    width: '100%',
    marginTop: '2.5vh',
    backgroundImage: `url(${src})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: 'contain',
  }),
  closeIcon: {
    position: 'fixed',
    top: 16,
    right: 16,
  },
}))

const Image = (props) => {
  const { src, width, height, className, popup = false } = props
  const classes = useStyles({ src, width, height, popup })
  const [open, setOpen] = useState(false)

  const handleOnClick = () => {
    if (popup) {
      setOpen(true)
    }
  }

  const onClose = () => { setOpen(false) }

  return (
    <>
      <div className={clsx(classes.root, className)} onClick={handleOnClick} />
      <Modal
        open={open}
        onEscapeKeyDown={onClose}
      >
        <div className={classes.modalBody}>
          <div className={classes.modalImage} />
          <div className={classes.closeIcon}>
            <IconButton color="primary" onClick={() => { setOpen(false) }}>
              <Close />
            </IconButton>
          </div>
        </div>
      </Modal>
    </>
  )
}

Image.propTypes = {}
Image.defaultProps = {}

export default Image

